import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 5v107.7h107.7V5H5zm86.2 86.2H26.5V26.5h64.6v64.7zM177.3 5v107.7H285V5H177.3zm86.2 86.2h-64.6V26.5h64.6v64.7zM5 177.3V285h107.7V177.3H5zm86.2 86.2H26.5v-64.6h64.6v64.6zM177.3 177.3V285H285V177.3H177.3zm86.2 86.2h-64.6v-64.6h64.6v64.6z"
})), 'ViewTilesIcon');